import { render, staticRenderFns } from "./Antalya-Suites-Comp.vue?vue&type=template&id=596c64e9&"
import script from "./Antalya-Suites-Comp.vue?vue&type=script&lang=js&"
export * from "./Antalya-Suites-Comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports